import Header from '../components/Header'; // importa o seu componente
import Hero from '../components/HeroSection/Hero';
import Franquia from '../components/Franquia';
import Indicadores from '../components/Indicadores';
import Funcionalidades from '../components/Funcionalidades';
import Clientes from '../components/Clientes'
import Planos from '../components/Planos'
import Depoimentos from '../components/Depoimentos'
import Footer from '../components/Footer'
import ContatoSuporte from '../components/ContatoSuporte';

export default function Home() {
  return (
    <div>
      <Header />
      <Hero />
      <Franquia />
      <Indicadores />
      <Funcionalidades />
      <Clientes />
      <Planos />
      <Depoimentos />
      <ContatoSuporte />
      <Footer />
    </div>
  );
}
